'use strict';

/**
 * library
 */
import objectFitImages from 'object-fit-images';

/**
 * fitimg
 */
export const fitimg = (() => {
    const init = () => {
        const $fitImage = $('.js-fit-image');

        if ($fitImage.length > 0) {
            objectFitImages($fitImage);
        }
    };

    return {
        init: init
    };
})();
